<div class="modal-header">
  <h4 class="modal-title">Find {{ type == "articles" ? "Article" : "Video" }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <div class="item-filter m-b-20 m-x-10">
    <div class="filter-input no-max-width">
      <input
        #searchInput
        type="text"
        [(ngModel)]="query"
        (keyup)="filter()"
        (keyup.enter)="search()"
        (focus)="focused = true"
        (blur)="focused = false"
        [placeholder]="type == 'articles' ? 'Search knowledgebase articles...' : 'Search videos...'"
      />
      <div class="extras d-flex align-items-center">
        @if (query) {
          <div class="clear" (click)="clear()"><fa-icon icon="times"></fa-icon></div>
        }
        @if (type == "articles") {
          <div class="search-btn" [class.active]="query" tabindex="0" (keyup.enter)="search()" (click)="search()">{{ "sphere.search" | translate }}</div>
        }
      </div>
      @if (focused && query && type == "articles") {
        <div class="text-muted t-12" style="position: absolute; bottom: -20px; left: 0px">Hit enter to search...</div>
      }
    </div>
  </div>
  <myp-inline-loader [loading]="searching" height="100px" spinnerName="registeringProductLoader"></myp-inline-loader>
  @if (type == "articles" && searchResults && searchResults.length) {
    @for (article of searchResults; track article) {
      <myp-list-item
        [subData]="['Created: ' + (article.created_at | date), article.description ? article.description : null]"
        [title]="article.name"
        [showImage]="false"
        (itemClicked)="selectContent(article)"
      ></myp-list-item>
    }
  }
  @if (type == "videos" && displayedVideos && displayedVideos.length) {
    <div class="grid-container wider pad-10">
      @for (item of displayedVideos; track item) {
        <myp-video-grid-item [selectable]="true" [video]="item" [showBorder]="true" (videoClickedEvent)="selectContent(item)"></myp-video-grid-item>
      }
    </div>
  }
  @if (type == "videos" && displayedVideos && !displayedVideos.length) {
    <div class="text-center m-y-50">No videos match your search.</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
